import React, { Component, ReactNode } from 'react';

interface IErrorBoundaryProps {
  children: ReactNode;
  message: string;
}

interface IErrorBoundaryState {
  error: null;
  errorInfo: null;
}

export class ErrorBoundary extends Component<IErrorBoundaryProps, IErrorBoundaryState> {
  constructor(props: IErrorBoundaryProps) {
    super(props);
    this.state = {
      error: null,
      errorInfo: null
    };
  }

  componentDidCatch(error: any, errorInfo: any) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  render() {
    if (this.state.errorInfo) {
      return <h5 style={{ marginLeft: '30px' }}>{this.props.message}</h5>;
    }
    return this.props.children;
  }
}
